import { GeoJSON } from 'ol/format';
import { LineString, Point } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import { getLength } from 'ol/sphere';
import { segmentStyle, defaultVectorStyle } from './styles';

export const geoJSON = new GeoJSON();

const segmentStyles = [segmentStyle];

const formatLength = function (line) {
    const length = getLength(line);
    let output;
    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + ' km';
    } else {
        output = Math.round(length * 100) / 100 + ' m';
    }
    return output;
};

export function styleFunction(feature, resolution, segments, defaultStyleFunction) {
    const styles = [];
    const geometry = feature.getGeometry();
    const type = geometry.getType();
    let line;

    if (defaultStyleFunction) {
        const defaults = defaultStyleFunction(feature, resolution);
        if (Array.isArray(defaults)) {
            styles.push(...defaults);
        }
        else {
            styles.push(defaults);
        }
    }
    else {
        styles.push(defaultVectorStyle);
    }

    if (type === 'Polygon') {
        line = new LineString(geometry.getCoordinates()[0]);
    } else if (type === 'LineString') {
        line = geometry;
    }
    if (segments && line) {
        let count = 0;
        line.forEachSegment(function (a, b) {
            const segment = new LineString([a, b]);
            const label = formatLength(segment);
            if (segmentStyles.length - 1 < count) {
                segmentStyles.push(segmentStyle.clone());
            }
            const segmentPoint = new Point(segment.getCoordinateAt(0.5));
            segmentStyles[count].setGeometry(segmentPoint);
            segmentStyles[count].getText().setText(label);
            styles.push(segmentStyles[count]);
            count++;
        });
    }

    return styles;
}

export function toStyleFunction(flatStyle) {
    return new VectorLayer({style: flatStyle}).getStyleFunction();
}

export function exportMap(map) {
    const mapCanvas = document.createElement('canvas');
    const size = map.getSize();
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];
    const mapContext = mapCanvas.getContext('2d');
    Array.prototype.forEach.call(
        map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
        (canvas) => {
            if (canvas.width > 0) {
                const opacity = canvas.parentNode.style.opacity || canvas.style.opacity;
                mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
                let matrix;
                const transform = canvas.style.transform;
                if (transform) {
                    // Get the transform parameters from the style's transform matrix
                    matrix = transform
                        .match(/^matrix\(([^(]*)\)$/)[1]
                        .split(',')
                        .map(Number);
                } else {
                    matrix = [
                        parseFloat(canvas.style.width) / canvas.width,
                        0,
                        0,
                        parseFloat(canvas.style.height) / canvas.height,
                        0,
                        0,
                    ];
                }
                // Apply the transform to the export map context
                CanvasRenderingContext2D.prototype.setTransform.apply(
                    mapContext,
                    matrix,
                );
                const backgroundColor = canvas.parentNode.style.backgroundColor;
                if (backgroundColor) {
                    mapContext.fillStyle = backgroundColor;
                    mapContext.fillRect(0, 0, canvas.width, canvas.height);
                }
                mapContext.drawImage(canvas, 0, 0);
            }
        },
    );
    mapContext.globalAlpha = 1;
    mapContext.setTransform(1, 0, 0, 1, 0, 0);
    return mapCanvas.toDataURL();
}